import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { link } from '@helpers/typography';
import svgTick from '@img/icons/interface/tick.svg?url';
import styled, { css } from 'styled-components';
export const CommonCheckboxContainerStyles = css `
  display: flex;
  flex-wrap: wrap;
  gap: ${fluid(12, 16)} ${fluid(24, 48)};

  flex-direction: column;

  @media ${from(Device.Tablet)} {
    flex-direction: row;
  }

  &[data-layout='vertical'] {
    flex-direction: column;
  }
`;
const Container = styled.div `
  ${CommonCheckboxContainerStyles};
`;
const Option = styled.div `
  display: flex;

  &:has(input:focus-visible) {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
  }

  @media ${from(Device.Tablet)} {
    white-space: nowrap;
  }
`;
const Input = styled.input `
  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;

  ${srOnly};
`;
export const CommonCheckboxLabelStyles = css `
  ${fonts.lato.regular};

  --bgColour: ${brand.global.white};
  --borderColour: ${brand.global.black};
  --borderRadius: 5px;
  --textColour: ${brand.global.black};
  --boxSize: 26px;

  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: ${fluid(14, 16)};
  line-height: var(--boxSize);
  color: var(--textColour);
  padding-left: calc(var(--boxSize) + ${fluid(10, 12)});

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    border-radius: var(--borderRadius);
    transform: translateY(-50%);
  }

  &::before {
    ${transition('opacity', 0.2)};

    background: var(--textColour);
    -webkit-mask-image: url(${svgTick});
    mask-image: url(${svgTick});
    mask-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    opacity: 0;
    z-index: 1;
    height: calc(var(--boxSize) + 2px);
    width: calc(var(--boxSize) + 2px);
  }

  &::after {
    background: var(--bgColour);
    border: 1px solid var(--borderColour);
    height: var(--boxSize);
    width: var(--boxSize);
  }

  a {
    ${link};
  }

  ${Input}:disabled + & {
    pointer-events: none;
    opacity: 0.5;
  }

  ${Input}:checked + &::before {
    opacity: 1;
  }
`;
const Label = styled.label `
  ${CommonCheckboxLabelStyles};
`;
const CheckboxListStyles = {
    Container,
    Input,
    Label,
    Option,
};
export default CheckboxListStyles;
